import { createRoot } from 'react-dom/client';
import '@uiw/reset.css';
import App from './App';
const container = document.getElementById('root');
const root = createRoot(container!);
root.render(<App />);